export default __webpack_public_path__ + "static/media/planet1.f5867362.png";